<div class="find-a-background-web">
    <div *ngIf="fromLocationSearch !== true" class="search-breadcrumb">
        <div class="search-breadcrumb-item" (click)="clearSearch()">{{breadcrumbText}}</div>
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="search-breadcrumb-item" (click)="returnToSearchResults()">{{breadcrumbText2}}</div> 
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="search-breadcrumb-item-2">{{details.providerName}}</div>
    </div>
    <div *ngIf="fromLocationSearch === true" class="search-breadcrumb">
        <div class="search-breadcrumb-item" (click)="clearSearch()">{{breadcrumbText}}</div>
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="search-breadcrumb-item" (click)="returnToSearchResults()">{{breadcrumbText2}}</div> 
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="search-breadcrumb-item" (click)="returnToLocationDetails()">{{locationDetails.locationName}}</div>
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="search-breadcrumb-item-2">{{details.providerName}}</div>
    </div>
    <hr style="margin: 0px 2.52rem; border: 1px solid #E0E0E0;">
    <div>
        <br>
        <div class="details-body-web">
            <div class="details-body-left">
                <div class="details-name-web" >{{details.providerName}}</div>
                <div class="details-specialties-web">{{details.specialties}}</div>
                <div class="details-photo-web">
                    <img [src]="details.photo || details.photoUrl ||'vudprovider.png'" alt="Provider photo">
                </div>
            </div>
            <div *ngIf="showSpinner == true" class="details-body-right" style="justify-content: center; align-items: start;">
                    <mat-spinner [diameter]="70"></mat-spinner>
            </div>
            <div *ngIf="showSpinner == false" class="details-body-right">
                <div *ngIf="details.about">
                    <div class="details-title-web">{{aboutLabel}}</div>
                    <div class="details-description-web" [innerHTML]="details.about"></div>
                </div>
                <div *ngIf="details.providerEducations !== null">
                    <div class="details-title-web">{{educationLabel}}</div>
                    <div *ngFor="let education of details.providerEducations">
                        <div class="details-subtitle-web">{{education.label}}</div>
                        <div class="details-description-web">{{education.institution}}</div>
                    </div>
                </div>
                <div *ngIf="details.languages !== null && details.languages !== ''">
                    <div class="details-title-web">{{langLabel}}</div>
                    <div class="details-description-web">{{details.languages}}</div>
                </div>
                <div *ngIf="details.affiliations !== null && details.affiliations !== ''">
                    <div class="details-title-web">{{affiliationsLabel}}</div>
                    <div class="details-description-web">{{details.affiliations}}</div>
                </div>
            </div>
        </div>
        <div *ngIf="details.nextAvailability !== null || (details.openScheduling != null && details.openScheduling == true)" class="details-body-bottom">
            <div *ngIf="waitTime !== null && waitTime !== ''" class="next-availability-container" style="text-align: right;">
                <div class="as-soon-as">Book as soon as</div>
                <div class="next-availability">{{waitTime}}</div>
            </div>
            <button class="details-btn-schedule-web" (click)="onScheduleButtonClicked()">
                <div>Schedule</div>
            </button>
        </div>
        <br>
        <hr style="margin: 0px 2.52rem; border: 1px solid #E0E0E0;">
        <br>
        <div *ngIf="locationList.length > 0" class="details-title-web custom-padding-web">{{locationsLabel}}</div>
        <div class="search-results-list-web custom-padding-web">
            <app-provider-search-details-location-card
                *ngFor="let location of locationList"
                [location]="location"
                [fromLocationSearch]="fromLocationSearch">
            </app-provider-search-details-location-card>
        </div>
        <br>
    </div>
</div>

